import { WidgetPage } from '@frontend/sports/types/components/widget';

export abstract class WidgetLayoutHook {
    constructor(readonly target: WidgetPage) {}

    abstract onResolve(): void;
    abstract onDestroy(): void;
}
